import React from "react";
import styles from "./Messenger.module.css";

const Settings = () => (
  <div className={styles.settingsBox}>
    <p>알림 설정</p>
    <p>프로필 변경</p>
    <p>테마 선택</p>
  </div>
);

export default Settings;
